import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	filterInputLabel: {
		id: string;
		defaultMessage: string;
	};
	addComponent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	caption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	// eslint-disable-next-line @atlassian/i18n/require-description
	filterInputLabel: {
		id: 'project.directories.components.header.filterInputLabel',
		defaultMessage: 'Filter components',
	},
	addComponent: {
		id: 'project-components.add-component.trigger',
		defaultMessage: 'Create component',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	caption: {
		id: 'project-components.header-caption',
		defaultMessage: 'Components',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	successFlagTitle: {
		id: 'project-components.add-component.success-flag-title',
		defaultMessage: 'Success',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	successFlagDescription: {
		id: 'project-components.add-component.success-flag-description',
		defaultMessage: 'New component was created successfully',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
